import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IDataContext } from '../../../core/component/list/component.interface';
import { InvoiceAttestStatus, InvoiceAttestStatusToString } from '../../model/const/enum';
import { Invoice } from '../../model/invoice';

@Component({
    selector: 'app-invoice-status',
    templateUrl: './invoice-status.component.html',
    styleUrls: ['./invoice-status.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceStatusComponent implements IDataContext {
  constructor() {}

  private _dataContext: Invoice | InvoiceAttestStatus;
  set dataContext(value: Invoice | InvoiceAttestStatus) {
    this._dataContext = value;
  }
  get dataContext(): Invoice | InvoiceAttestStatus {
    return this._dataContext;
  }

  private get invoiceLike(): Invoice | null {
    return this.dataContext && typeof this.dataContext === 'object' && 'attestStatus' in this.dataContext ? (this.dataContext as Invoice) : null;
  }

  private get attestStatus(): InvoiceAttestStatus | null {
    if (typeof this.dataContext === 'number') {
      return this.dataContext as InvoiceAttestStatus;
    }

    return this.invoiceLike?.attestStatus ?? null;
  }

  get faIconClass(): string {
    const s = this.attestStatus;
    if (s === InvoiceAttestStatus.Completed) return 'fa-light fa-circle-check';
    if (s === InvoiceAttestStatus.Pending) return 'fa-light fa-timer';
    if (s === InvoiceAttestStatus.Failed) return 'fa-light fa-circle-xmark';
    return 'fa-light fa-circle-pause';
  }
  get errorMessage(): string {
    return this.invoiceLike?.errorMessage ?? '';
  }
  get statusText(): string {
    return this.attestStatus !== null ? InvoiceAttestStatusToString(this.attestStatus) : '';
  }
  get textClass(): any {
    const s = this.attestStatus;
    return {
      'attested-text': s === InvoiceAttestStatus.Completed,
      'in-process-text': s === InvoiceAttestStatus.Pending,
      'not-attested-text': s === InvoiceAttestStatus.NotRequested,
      'failed-text': s === InvoiceAttestStatus.Failed,
    };
  }
}
